export const APP_MODES = Object.freeze({
  INCIDENT: 'incident',
  LEGAL: 'legal',
});

export function normalizeAppMode(value) {
  return value === APP_MODES.LEGAL ? APP_MODES.LEGAL : APP_MODES.INCIDENT;
}

export function getInitialAppMode(defaultMode) {
  return normalizeAppMode(sessionStorage.getItem('appMode') || defaultMode);
}
